import { cn } from 'src/lib/utils';
import { portalDs } from './portal-ds-classes';

export type PortalDsBadgeVariant = 'blue' | 'green' | 'amber' | 'red' | 'gray';

const BADGE_VARIANTS: Record<PortalDsBadgeVariant, string> = {
  blue: portalDs.badgeBlue,
  green: portalDs.badgeGreen,
  amber: portalDs.badgeAmber,
  red: portalDs.badgeRed,
  gray: portalDs.badgeGray,
};

const STATUS_PILL_VARIANTS: Record<PortalDsBadgeVariant, string> = {
  blue: portalDs.statusPillInfo,
  green: portalDs.statusPillSuccess,
  amber: portalDs.statusPillWarning,
  red: portalDs.statusPillDanger,
  gray: portalDs.statusPillGray,
};

interface PortalDsBadgeProps {
  variant?: PortalDsBadgeVariant;
  children: React.ReactNode;
  className?: string;
  pill?: boolean;
}

export function PortalDsBadge({
  variant = 'gray',
  children,
  className,
  pill = false,
}: PortalDsBadgeProps) {
  return (
    <span
      className={cn(
        pill ? portalDs.statusPill : portalDs.badgeBase,
        pill ? STATUS_PILL_VARIANTS[variant] : BADGE_VARIANTS[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
